import { render } from "./form-container.vue?vue&type=template&id=4013c445&scoped=true"
import script from "./form-container.vue?vue&type=script&lang=js"
export * from "./form-container.vue?vue&type=script&lang=js"

import "./form-container.vue?vue&type=style&index=0&id=4013c445&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4013c445"]])

export default __exports__